// import BaseChart from './BaseChart'
import ReactECharts from "echarts-for-react";

export default function BarChart(props) {
    const BarOption = {
        title: {
          left: 'left',
          text: props.title
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: props.category,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: 'Data',
              type: 'bar',
              barWidth: '60%',
              data: props.data
            }
          ]
      };
    return (
        <div>
            <ReactECharts
                option={props.option}
                style={props.style}
            />
                   </div>
    )
}

